import React from "react";
import EntityList from "../EntityList/EntityList";
import { defineMessages, injectIntl } from "react-intl";
import swal from "sweetalert";
import { withPropertyData } from "../../../../components/property-admin-data-provider";

const messages = defineMessages({
  inventoriesWarning: {
    id: "app.conditionsList.inventoriesWarning",
    description: "This condition is being used in some inventory lines, it can not be deleted.",
    defaultMessage: "This condition is being used in some inventory lines, it can not be deleted.",
  },
  close: {
    id: "app.conditionsList.close",
    description: "Close",
    defaultMessage: "Close",
  },
  disabledDelete: {
    id: "app.conditionsList.tooltip.delete",
    description: "Message for tooltip disabled delete",
    defaultMessage: "Disabled delete",
  },
});

/* TODO: There's a problem with the API, on UPDATE the id changes, is that normal?
 * Also when updating and the entity does not exists it returns a 200 instead of a 404 */
class ConditionsList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.state = {
      entities: [],
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleToggle({ event, entity }) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      activeProperty: "active",
    });
  }

  handleDelete({ event, entity }) {
    event.preventDefault();
    event.stopPropagation();

    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  }

  handleClone = params => this.props.onCloneListItem(params);

  customEntityToListValuesMapper = ({ entities, currentLocale }) => {
    return entities.map(oldEntity => {
      const entity = { ...oldEntity };
      const currentTranslation =
        entity.translations &&
        entity.translations.find(translation => translation.locale === currentLocale);

      entity.name = currentTranslation ? currentTranslation.name : entity.name;
      entity.allowDelete = !(this.props.wbkData.conditionsInUse || []).includes(entity.ticker);

      return entity;
    });
  };

  render() {
    const { name, entityName, validation, fields, renderers, allowClone } = this.props.config;
    const { handleToggle, handleDelete } = this;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;

    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        onClone={this.handleClone}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        customEntityToListValuesMapper={this.customEntityToListValuesMapper}
        currentLocale={this.props.config.locale}
        success={success}
        allowClone={allowClone}
        customActions={[
          {
            classNames: "btn-danger disabled",
            icon: "fa fa-trash-o",
            tooltipId: "delete-custom",
            tooltipText: this.props.intl.formatMessage(messages.disabledDelete),
            onExecute: ({ event, entity, index }) => {
              swal({
                text: this.props.intl.formatMessage(messages.inventoriesWarning),
                icon: "warning",
                buttons: {
                  cancel: this.props.intl.formatMessage(messages.close),
                },
                dangerMode: true,
              });
            },
            isAvailable: ({ event, entity, index }) =>
              (this.props.wbkData.conditionsInUse || []).includes(entity.ticker),
          },
        ]}
      />
    );
  }
}

ConditionsList.defaultProps = {
  entities: [],
};

export default injectIntl(withPropertyData(ConditionsList));
